<template>
  <div>
    <div
      v-if="
        show &&
        (ext.toLocaleUpperCase() == '.MP4' || ext.toLocaleUpperCase() == '.FLV')
      "
    >
      <div class="video-preview" @click="handleClose"></div>
      <video class="video" controls="controls" autoplay="autoplay">
        <source :src="urls[0]" type="video/mp4" />
      </video>
    </div>
    <div
      v-if="
        show &&
        (ext.toLocaleUpperCase() == '.JPG' ||
          ext.toLocaleUpperCase() == '.PNG' ||
          ext.toLocaleUpperCase() == '.DOC' ||
          ext.toLocaleUpperCase() == '.DOCX' ||
          ext.toLocaleUpperCase() == '.PDF')
      "
    >
      <el-image-viewer :on-close="handleClose" :url-list="urls" />
    </div>
  </div>
</template>

<script>
// 导入组件
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  props: {
    urls: {
      type: Array,
      default: [],
    },
    show: {
      type: Boolean,
      default: false,
    },
    ext: {
      type: String,
      default: "",
    },
  },
  components: {
    ElImageViewer,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleClose() {
      // console.log("close")
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.video-preview {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgb(140, 146, 150);
  display: block;
  filter: alpha(opacity=60);
  -moz-opacity: 0.6;
  -khtml-opacity: 0.6;
  opacity: 0.6;
  top: 0px;
  left: 0px;
  z-index: 2000;
}
.video {
  width: 80%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  z-index: 2001;
}
/deep/ .el-image-viewer__actions {
    opacity: 1;
}
/deep/ .el-image-viewer__close{
  opacity: 1;
}
</style>